// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useDisputeSettlementObligation } from '@hooks/mutations/collateral/settlmentObligation/useDisputeSettlementObligation';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { CollateralAgreement_SettlementObligation } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral';
import { ContractId } from '@daml/types';
import FormDialog from '../../../../components/Dialog/FormDialog';
import TextInput from '../../../../components/Form/TextInput';
import { useDisputeSettlementObligationForm } from './useDisputeSettlementObligationForm';

interface CancelInstructDialogProps {
  settlementObligationCId: ContractId<CollateralAgreement_SettlementObligation>;
  open: boolean;
  onClose: () => void;
}

export const DisputeSettlementObligationDialog: React.FC<CancelInstructDialogProps> = ({
  settlementObligationCId,
  open,
  onClose,
}) => {
  const disputeSettlementObligation = useDisputeSettlementObligation();

  const form = useDisputeSettlementObligationForm();

  const handleSubmit = React.useCallback(async () => {
    await disputeSettlementObligation({
      cid: settlementObligationCId,
      argument: {
        reason: form.reason,
      },
    });
    onClose();
    return Promise.resolve();
  }, [form, onClose, disputeSettlementObligation, settlementObligationCId]);
  return (
    <FormDialog
      open={open}
      submitButtonSxProps={{ color: 'error' }}
      title={
        <Typography fontWeight="bold" variant="h6" color="error">
          Cancel Settlement Obligation
        </Typography>
      }
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName="Continue"
    >
      <Box>
        <TextInput
          enableTopLabel
          placeholder="Enter a reason for the dispute"
          label="Reason"
          value={form.reason}
          setValue={form.setReason}
        />
      </Box>
    </FormDialog>
  );
};
